import React from 'react';

export interface InteractiveLink {
  id: string;
  data: {
    text: string;
  url: string;
  },
  start_time: number;
  end_time: number;
  type: string;
}





interface InteractiveLinksProps {
  links: InteractiveLink[];
  currentTime: number;
  onLinkClick: (link: InteractiveLink) => void;
}

const InteractiveLinks: React.FC<InteractiveLinksProps> = ({ links, currentTime, onLinkClick }) => {
  const visibleLinks = links.filter((link) => currentTime >= link.start_time && currentTime <= link.end_time);

  if (visibleLinks.length === 0) {
    return null;
  }

  return (
    <div className="absolute top-4 right-4 z-30 flex flex-col gap-2">
      {visibleLinks.map((link, index) => (
        <div
          key={link.id}
          className="bg-white bg-opacity-95 text-black px-4 py-3 rounded-lg cursor-pointer hover:bg-opacity-100 hover:scale-105 transition-all duration-200 max-w-xs shadow-xl border border-gray-500 backdrop-blur-sm"
          style={{
           
            boxShadow: '0 0 20px rgba(255, 255, 255, 0.1)',
          }}
          onClick={() => onLinkClick(link)}
        >
          <div className="flex items-center gap-2">
            {link.type === 'url' && (
              <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
              </svg>
            )}
            {link.type === 'document' && (
              <svg className="w-4 h-4 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
            )}
            {link.type === 'contact' && (
              <svg className="w-4 h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
              </svg>
            )}
            {link.type === 'video' && (
              <svg className="w-4 h-4 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
              </svg>
            )}
            {link.type === 'external' && (
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
              </svg>
            )}
            {link.type === 'info' && (
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            <span className="text-sm font-medium truncate">{link.data.text}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InteractiveLinks;